import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'CLOSE_OPER',
  title: 'Wie schließt man ein Projekt ab?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'So schließen Sie ein Projekt:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf die Registerkarte "Projekte"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLOSE_OPER/DE_CLOSE_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf das Projekt Ihrer Wahl'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLOSE_OPER/DE_CLOSE_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie auf die 3 Punkte oben rechts'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLOSE_OPER/DE_CLOSE_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Klicken Sie auf "Projekt schließen"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLOSE_OPER/DE_CLOSE_OPER_4.png`
  }]
};
